/*
 *
 * App constants
 *
 */

export const SLICE_NAME = 'app';
